import React, { useState } from 'react';

import getIcons from '../../functions/getIcons/getIcons';

const styles = {
	searchBoxOverlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		// top: 0,
		top: '50px',
		zIndex: 10,
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	privacyBtnContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	privacyBtn: {
		fontWeight: '500',
		fontSize: '20px',
		fontColor: '#fff',
		borderBottom: '2px solid #fff',
	},
	privacyCloseIconContainer: { width: '25px', marginLeft: 'auto' },
	privacyCloseIcon: {
		marginBottom: '-50px',
		cursor: 'pointer',
	},
};
const ThemeTwoTnCSection = props => {
	const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
	const { history, operator } = props;
	const createMarkup = data => {
		return {
			__html: data,
		};
	};

	// Determine the background color based on the operator
	const backgroundColor = props.operator && props.operator.operator_name === 'biaggini'
		? '#0092c5' : props.operator && props.operator.operator_name === 'santarosa'
			? '#EEF0F1'
			: props.operator &&
				props.operator.color_codes &&
				props.operator.color_codes.secondary_color
				? props.operator.color_codes.secondary_color
				: undefined; // Use existing logic for other operators



	const santacolor = operator && operator.operator_name === "santarosa" ? '#464647' : null;
	return (
		operator && operator.operator_name !== "expresosantacruz" && operator && operator.operator_name === "santarosa" || operator && operator.operator_name === "buseslafit" ?
			(
				<div
					className={operator && operator.operator_name === "buseslafit" ? "themes-theme-two-tn-c-section new-container roundborder scrollclass lafitscroll" : "themes-theme-two-tn-c-section new-container roundborder scrollclass "}
					style={{
						background: backgroundColor,
						color: operator && operator.operator_name === "santarosa" ? santacolor : operator && operator.color_codes && operator.color_codes.secondary_text_color,
					}}
				>
					<style>
						{`.color {
          color: ${props.operator &&
								props.operator.color_codes &&
								props.operator.color_codes.button_color
								? props.operator.color_codes.button_color
								: 'inherit'  // Set default color handling if not defined
							};
      }`}
					</style>
					<div
						dangerouslySetInnerHTML={createMarkup(
							props.operator && props.operator.terms ? props.operator.terms : '',
						)}
						className="themes-theme-two-tn-c-section new-container  "
					/>
					<p></p>
				</div>
			) :
			(<div
				className="themes-theme-two-tn-c-section new-container"
				style={{
					flex: 1,
					background: backgroundColor,
					color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
				}}
			>
				<div
					dangerouslySetInnerHTML={createMarkup(operator && operator.terms ? operator.terms : '')}
				/>
				<div style={styles.privacyBtnContainer}>
					{!showPrivacyPolicy ? (
						<a style={styles.privacyBtn} onClick={() => setShowPrivacyPolicy(!showPrivacyPolicy)}>
							Ver más
						</a>
					) : (
						<div style={styles.privacyCloseIconContainer}>
							<img
								style={styles.privacyCloseIcon}
								src={getIcons('close2', operator)}
								onClick={() => setShowPrivacyPolicy(false)}
							/>
						</div>
					)}
				</div>
				{showPrivacyPolicy && (
					<div
						style={{ marginTop: '50px' }}
						dangerouslySetInnerHTML={createMarkup(
							operator && operator.privacy_policy ? operator.privacy_policy : '',
						)}
					/>
				)}
			</div>)


	);
};
export default ThemeTwoTnCSection;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/ThemeTwoTnCSection.js